export const getRefCodeFromParam = () => {
  let refCode;

  try {
    const url = new URL(window.location);

    refCode = url.searchParams.get('ref_code');
  } catch (e) {
    // do nothing
  }

  if (!refCode) {
    const referrer = document.referrer;

    if (referrer) {
      try {
        const url = new URL(referrer);

        refCode = url.searchParams.get('ref_code');
      } catch (e) {
        // do nothing
      }
    }
  }

  return refCode;
};

export default { getRefCodeFromParam };
